import { SvgIcon, SxProps } from "@mui/material";
import SvgReplyIcon from "jsx:../../../Images/Icons/FontAwesome/light/reply.svg";

export function ReplyIcon(props: SxProps) {
    return <SvgIcon component={SvgReplyIcon} inheritViewBox sx={props} />;
}
